export const actions = {
  set_state: 'profile/set_state',
  get_profile: 'profile/get_profile',
  update_profile: 'profile/update_profile',
  update_password: 'profile/update_password',
  update_email: 'profile/update_email',
  verify_email: 'profile/verify_email'
}
